import Vue from 'vue'
import Lockr from 'lockr'
import {keyBy, find, filter} from 'lodash'
window.Lockr = Lockr
import UUID from 'uuid/v4'

let VueStorageMixin = {
  methods: {
    save() {
      this.storage.save(Object.assign({}, this.$data))
    },

    destroy() {
      this.storage.destroy(this.$data)
    },
  },
  computed: {
    storage() {
      return this.__proto__.constructor.storage
    }
  }
}

class Storage {

  static get Vue() {
    return VueModel
  }

  constructor(initializerClass) {
    this.initializerClass = initializerClass
  }

  recordsName() {
    return this.initializerClass.name
  }

  save(record) {
    if (!record.uuid) {
      record.uuid = UUID()
    }
    let records = this.allPlain().filter(oldRecord => record.uuid != oldRecord.uuid)
    records.push(record)
    Lockr.set(this.recordsName(), records)
    return true
  }

  destroy(recordToDelete) {
    Lockr.set(this.recordsName(), this.allPlain().filter(record => record.uuid != recordToDelete.uuid))
    return true
  }

  all() {
    return this.allPlain().map((attributes)=>{
      return new this.initializerClass(attributes)
    })
  }

  allGrouped(key='uuid') {
    return _.keyBy(this.all(), key)
  }

  allPlainGrouped(key='uuid') {
    return _.keyBy(this.allPlain(), key)
  }

  find(identifier, key='uuid') {
    return _.find(this.all(), [key, identifier])
  }

  findAll(identifier, key='uuid') {
    return _.filter(this.all(), [key, identifier])
  }

  deleteAll() {
    Lockr.set(this.recordsName(), null)
    return true
  }

  mergeAll(records) {
    let saveSet = this.allPlainGrouped('uuid')
    for(let record of records) {
      saveSet[record.uuid] = record
    }
    this.replaceAll(Object.values(saveSet))
  }

  replaceAll(records) {
    Lockr.set(this.recordsName(), records)
    return true
  }

  allPlain() {
    return (Lockr.get(this.recordsName()) || [])
  }

}

class VueModel extends Vue {

  constructor(vueOptions) {
    vueOptions.mixins = [VueStorageMixin]
    if (!vueOptions.data) {
      vueOptions = {
        data: vueOptions
      }
    }
    // if (!vueOptions.data.uuid) {
    //   vueOptions.data.uuid = UUID()
    // }
    return super(vueOptions)
  }

  static get storage() {
    return new Storage(this)
  }
}


export default Storage